import React from 'react';
import { FontWeight, HStack, Text } from '@doveit/bricks';
import ViewProspectPopoverPreview from '../../containers/view-prospect-popover-preview/ViewProspectPopoverPreview';
import { Prospect } from '../../../providers/api/dtos';
import ProspectAvatar from '../prospect-avatar/ProspectAvatar';
import useLead from '../../../lead/hooks/use-lead/useLead';
import { setVerticalEllipsis } from '../../../utils/styles/verticalEllipsis.style';

export interface ProspectPreviewProps extends React.AriaAttributes {
  prospect: Prospect,
}

const ProspectPreview: React.FC<ProspectPreviewProps> = ({
  prospect,
  ...rest
}) => {
  const { data: lead } = useLead(prospect.leadId);

  return (
    <ViewProspectPopoverPreview
      {...rest}
      propertyAddress={lead?.propertyAddress || 'Indirizzo mancante'}
      prospect={prospect}
      trigger={(
        <HStack gap={100} wrap="nowrap">
          <ProspectAvatar size="S" />
          <Text.BodySmall
            aria-label="Indirizzo immobile"
            fontWeight={FontWeight.MEDIUM}
            css={setVerticalEllipsis()}
          >
            {lead?.propertyAddress || 'Indirizzo mancante'}
          </Text.BodySmall>
        </HStack>
      )}
    />
  );
};

export default ProspectPreview;
